import { Component, HostListener } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { EnderecoPessoa } from '../../models/pessoa.model';
import { HelpersUtil } from '../../utils/helpers.util';
import { DialogStateUtil } from '../../utils/dialog-state.util';

@Component({
  selector: 'app-selecionar-endereco-delivery-dialog',
  templateUrl: './selecionar-endereco-delivery-dialog.component.html',
  styleUrls: ['./selecionar-endereco-delivery-dialog.component.scss']
})
export class SelecionarEnderecoDeliveryDialogComponent {
  //componentProps
  public readonly enderecos: EnderecoPessoa[] = [];

  public indexEnderecoSelecionado = -1;

  constructor(
    private _modalCtrl: ModalController
  ) { }

  public async cancelarAsyncOnClick() {
    await this._cancelarAsync();
  }

  @HostListener('document:keydown', ['$event'])
  private async _lidarComKeyboardEventAsync(event: KeyboardEvent) {
    switch (event.key) {
      case KeyboardKeysEnum.ArrowUp:
        event.preventDefault();
        event.stopPropagation();
        this._lidarComArrowUpKey();
        break;
      case KeyboardKeysEnum.ArrowDown:
        event.preventDefault();
        event.stopPropagation();
        this._lidarComArrowDownKey();
        break;
      case KeyboardKeysEnum.Enter:
        event.preventDefault();
        event.stopPropagation();
        this._lidarComEnterKeyAsync();
        break;
      case KeyboardKeysEnum.Escape:
        await this._cancelarAsync();
        break;
    }
  }

  private async _confirmarAsync() {
    const enderecoSelecionado = this.enderecos[this.indexEnderecoSelecionado];

    await this._modalCtrl.dismiss(new SelecionarEnderecoDeliveryDataClose(enderecoSelecionado), ModalRoleEnum.CONFIRM);

    DialogStateUtil.dialogIsClosed();
  }

  private async _cancelarAsync() {
    await this._modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);

    DialogStateUtil.dialogIsClosed();
  }

  private _lidarComArrowDownKey() {
    this.indexEnderecoSelecionado = HelpersUtil.selectNextItem(this.indexEnderecoSelecionado, this.enderecos.length);

    const element = document.querySelector(`[data-endereco-index="${this.indexEnderecoSelecionado}"]`);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  private _lidarComArrowUpKey() {
    this.indexEnderecoSelecionado = HelpersUtil.selectPreviousItem(this.indexEnderecoSelecionado);

    const element = document.querySelector(`[data-endereco-index="${this.indexEnderecoSelecionado}"]`);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  private async _lidarComEnterKeyAsync() {
    await this._confirmarAsync();
  }
}

export class SelecionarEnderecoDeliveryDataClose {
  constructor(
    public endereco: EnderecoPessoa
  ) { }
}